import axios from "axios";
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { toast } from "react-toastify";
import Select from "react-select";

const CHARTACCOUNT_FIELD_RULES = {
    wording: { label: "Le libellé de la caisse", required: true, minLength: 2, maxLength: 100 },
    accounting_code: { label: "La référence de la caisse", required: true, maxLength: 50 },
    currency: { label: "La devise", required: true },
};

class ChartaccountForm extends Component {
    state = {
        id: "",
        coded: "",
        accounting_code: "",
        wording: "",
        collectif: "Collectif",
        chartaccount_id: "",
        currency: "",
        error: "",
        errors: {},
        title: "",
        btn: false,
    };

    handleInput = (e) => {
        const { name, value } = e.target;

        this.setState((state) => ({
            [name]: value,
            error: "",
            errors: { ...state.errors, [name]: "" },
        }));
    };

    validate = () => {
        const errors = {};

        Object.entries(CHARTACCOUNT_FIELD_RULES).forEach(([name, rule]) => {
            const value = String(this.state[name] ?? "").trim();

            if (rule.required && !value) {
                errors[name] = `${rule.label} est obligatoire.`;
            } else if (value && rule.minLength && value.length < rule.minLength) {
                errors[name] = `${rule.label} doit contenir au moins ${rule.minLength} caractères.`;
            } else if (value && rule.maxLength && value.length > rule.maxLength) {
                errors[name] = `${rule.label} ne peut pas dépasser ${rule.maxLength} caractères.`;
            }
        });

        return errors;
    };

    storeChartaccount = async (val = null) => {
        const errors = this.validate();

        if (Object.keys(errors).length) {
            this.setState({
                errors,
                error: Object.values(errors)[0],
            });
            return;
        }

        try {
            this.setState({ btn: true, error: "", errors: {} });

            const data = {
                coded: this.state.coded,
                accounting_code: String(this.state.accounting_code || "").trim(),
                wording: String(this.state.wording || "").trim(),
                collectif: this.state.collectif || "Collectif",
                chartaccount_id: this.state.chartaccount_id || null,
                currency: this.state.currency,
                operation: this.state.id ? (val === 1 ? "Archiver" : "Editer") : "Ajouter",
            };

            const request = this.state.id
                ? axios.put(`chartaccounts/${this.state.id}`, data)
                : axios.post("chartaccounts", data);

            const response = await request;

            toast(response?.data?.msg || "Opération effectuée avec succès.", {
                theme: "light",
                style: { backgroundColor: "blue", color: "white" },
            });

            this.setState({ btn: false });
            this.props.showModal(null, false, 1);
        } catch (error) {
            const message = error.response?.data?.msg || "Une erreur est survenue.";

            this.setState({
                error: message,
                btn: false,
            });

            toast(message, {
                theme: "light",
                style: { backgroundColor: "red", color: "white" },
            });
        }
    };

    edit = () => {
        this.form();
    };

    form = () => {
        this.setState({
            id: this.props.formData ? this.props.formData.id : "",
            coded: this.props.formData ? this.props.formData.coded : "",
            collectif: this.props.formData ? this.props.formData.collectif : "Collectif",
            accounting_code: this.props.formData ? this.props.formData.accounting_code : "",
            chartaccount_id: this.props.formData ? this.props.formData.chartaccount_id : "",
            currency: this.props.formData ? this.props.formData.currency : "",
            wording: this.props.formData ? this.props.formData.wording : "",
            title: this.props.formData && this.props.formData.id ? "Modifier la caisse" : "Ajouter une caisse",
            error: "",
            errors: {},
            btn: false,
        });
    };

    render() {
        const selectMenuProps = {
            menuPortalTarget: typeof document !== "undefined" ? document.body : null,
            menuPosition: "fixed",
            classNamePrefix: "student-select",
            styles: { menuPortal: (base) => ({ ...base, zIndex: 1060 }) },
        };

        const currencyOptions = [
            { value: "USD", label: "USD" },
            { value: "CDF", label: "CDF" },
        ];

        return (
            <div>
                <Modal
                    show={this.props.isModal}
                    onHide={this.props.showModal}
                    size="md"
                    dialogClassName="sectionclasse-form"
                    contentClassName="student-form-modal student-form-modal--compact"
                    onEntered={this.edit}
                    backdrop="static"
                >
                    <Modal.Header>
                        <div className="student-form__heading">
                            <span className="student-form__heading-icon">
                                <FeatherIcon icon="credit-card" size="20" />
                            </span>
                            <div>
                                <span className="student-form__eyebrow">Comptabilité</span>
                                <Modal.Title>{this.state.title}</Modal.Title>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="row student-form__body">
                        {this.state.error && (
                            <div className="col-12">
                                <div className="student-form__alert" role="alert">
                                    <FeatherIcon icon="alert-circle" size="17" />
                                    <span>{this.state.error}</span>
                                </div>
                            </div>
                        )}

                        <div className="col-12 student-form__section-title">
                            <span>
                                <FeatherIcon icon="briefcase" size="16" />
                            </span>
                            <div>
                                <strong>Informations de la caisse</strong>
                                <small>Libellé, référence comptable et devise utilisée</small>
                            </div>
                        </div>

                        {/* <div className="col-md-4 mt-2 d-none">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="coded">
                                    Code
                                </label>
                                <div className="position-relative mt-1">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Code"
                                        onChange={this.handleInput}
                                        name="coded"
                                        value={this.state.coded}
                                        id="coded"
                                    />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="trello" />
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="col-md-12 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="wording">
                                    Libellé de la caisse <span className="text-danger">*</span>
                                </label>
                                <div className="position-relative mt-1">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        onChange={this.handleInput}
                                        name="wording"
                                        value={this.state.wording}
                                        id="wording"
                                        maxLength={100}
                                    />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="package" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="accounting_code">
                                    Référence de la caisse <span className="text-danger">*</span>
                                </label>
                                <div className="position-relative mt-1">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        onChange={this.handleInput}
                                        name="accounting_code"
                                        value={this.state.accounting_code}
                                        id="accounting_code"
                                        maxLength={50}
                                    />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="hash" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6 mt-2">
                            <label className="font-monospace fw-normal">
                                Devise <span className="text-danger">*</span>
                            </label>
                            <Select
                                {...selectMenuProps}
                                className="form-control form-control-sm p-0"
                                placeholder="Devise de paiement"
                                value={currencyOptions.filter((option) => option.value === this.state.currency)}
                                onChange={(select) =>
                                    this.setState((state) => ({
                                        currency: select.value,
                                        error: "",
                                        errors: { ...state.errors, currency: "" },
                                    }))
                                }
                                options={currencyOptions}
                            />
                        </div>

                        <div className="col-md-6 mt-2 d-none">
                            <label className="font-monospace fw-normal">Type</label>
                            <div className="ev-choice-group mt-2">
                                <label className="ev-choice" htmlFor="collectif">
                                    <input
                                        id="collectif"
                                        type="radio"
                                        name="collectif"
                                        value="Collectif"
                                        checked={this.state.collectif === "Collectif"}
                                        onChange={this.handleInput}
                                    />
                                    <span>Collectif</span>
                                </label>

                                <label className="ev-choice" htmlFor="non-collectif">
                                    <input
                                        id="non-collectif"
                                        type="radio"
                                        name="collectif"
                                        value="Non collectif"
                                        checked={this.state.collectif === "Non collectif"}
                                        onChange={this.handleInput}
                                    />
                                    <span>Non collectif</span>
                                </label>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <span className="student-form__footer-note">
                            <FeatherIcon icon="info" size="14" /> Les champs marqués d’un * sont obligatoires
                        </span>

                        <button
                            type="button"
                            onClick={this.props.showModal}
                            className="btn btn-light student-form__button"
                            disabled={this.state.btn}
                        >
                            <FeatherIcon icon="x" size="16" /> Fermer
                        </button>

                        <button
                            type="button"
                            onClick={() => this.storeChartaccount()}
                            className="btn btn-primary student-form__button"
                            disabled={this.state.btn}
                        >
                            <FeatherIcon icon="check" size="16" />
                            {this.state.btn ? "Enregistrement..." : "Sauvegarder"}
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default ChartaccountForm;